import { render, staticRenderFns } from "./PreviewForm12.vue?vue&type=template&id=0720ae2b&scoped=true"
import script from "./PreviewForm12.vue?vue&type=script&lang=ts"
export * from "./PreviewForm12.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720ae2b",
  null
  
)

export default component.exports